<template lang="pug">
  .sale-dates
    .title Sale Dates
    .sale-dates-list(v-if="brands && brands.length > 0")
      .sale-dates-item(v-for="brand in brands" :key="brand.id")
        .dark {{ brand }}
        .initial-date(v-if="dates[brand]")
          label Inicio
          input(type="date" v-model="dates[brand].initialDate")
        .end-date(v-if="dates[brand]")
          label Fin
          input(type="date" v-model="dates[brand].endDate")
        .name(v-if="dates[brand]")
          label Nombre Promoción
          input(type="text" v-model="dates[brand].name" placeholder="ej: hotsale, bf, anniversary")
        div
          shActionButton(text="Guardar" :action="updateSaleDates" :params="[brand]" :principalColor="true")
</template>

<script>
import gqlSaleDates from '@/graphql/saleDates'
import gql from '@my/graphql'
import shActionButton from '@/components/elements/ActionButton'
import modals from '@my/store/modals'

export default {
  name: 'SaleDates',

  components: { shActionButton, modals },

  data () {
    return {
      dates: {}
    }
  },

  mounted () {
    if (this.brands && this.brands.length > 0) {
      this.getSaleDates()
    }
  },

  methods: {
    async getSaleDates () {
      const { data } = await gql.query(gqlSaleDates.GET_ALL)
      const saleDates = data.getSaleDates

      // Limpiar el objeto dates
      this.dates = {}

      // Llenar con las fechas que vienen del backend
      saleDates.forEach(saleDate => {
        const { brand, initialDate, endDate, name } = saleDate
        const formatDate = (dateString) => dateString ? dateString.split('T')[0] : ''
        this.$set(this.dates, brand, {
          initialDate: formatDate(initialDate),
          endDate: formatDate(endDate),
          name: name || ''
        })
      })

      // Para las marcas que no vinieron del backend, inicializar vacío
      this.brands.forEach(brand => {
        if (!this.dates[brand]) {
          this.$set(this.dates, brand, { initialDate: '', endDate: '', name: '' })
        }
      })
    },

    async updateSaleDates (brand) {
      const dates = this.dates[brand]

      if (!dates.initialDate) {
        modals.showMessage({ message: 'Elige una fecha de inicio', type: 'error' })
        return
      }

      if (!dates.endDate) {
        modals.showMessage({ message: 'Elige una fecha de fin', type: 'error' })
        return
      }

      await gql.mutate(gqlSaleDates.UPDATE, { brand: brand, initialDate: dates.initialDate, endDate: dates.endDate, name: dates.name })

      modals.showMessage({ message: 'Fecha de promoción actualizada', type: 'ok' })
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    brands () {
      this.getSaleDates()
    }
  }
}
</script>

<style lang="stylus" scoped>
.sale-dates-list
  display flex
  flex-direction column
  gap 1rem
  align-items center
  justify-content center
  padding 1rem
  border-radius 1rem
  margin-bottom 1rem

.sale-dates-item
  display inline-flex
  flex-direction column
  gap 1rem
  align-items center
  justify-content center
  padding 1rem
  border-radius 1rem
  margin-bottom 1rem
  .initial-date, .end-date, .name
    display flex
    flex-direction column
    gap 0.5rem
</style>



// WEBPACK FOOTER //
// src/components/pages/saleDates/SaleDates.vue